<template>
  <div class="index">
    <div class="index-main">
    <div class="index-logo">
      <div class="index-logo-img"></div>
      <span>YUI</span>
    </div>
    <div class="index-content">
      <y-col span="24">
        <div class="index-title">YUI</div>
        <div class="index-desc">一套基于Vue.js的UI组件库</div>
        <div class="index-keyword">简约 轻巧 好用</div>
        <ul class="index-action">
          <router-link to="/guide" tag="li">开始使用</router-link>
          <li><a href="https://github.com/Leioy/vue-wheel" target="_blank"><y-icon name="github" style="margin-right:5px;"></y-icon>Github</a></li>
        </ul>
      </y-col>
    </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'home',
}
</script>
<style lang="scss" scoped>
.index {
  height: 100vh;
  background: url('../assets/bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  &-main {
    position: relative;
    width: 50%;
    height: 100vh;
    padding-left: 10%;
    text-align: left;
  }
  &-logo {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    margin-top: 20px;
    font-weight: 800;
    font-size: 30px;
    font-style: italic;
    text-align: left;
    &-img {
      width: 30px;
      height: 30px;
      background: url('../assets/logo.png');
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
  &-content {
    margin-top: -40px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &-title {
    font-size: 50px;
    text-align: left;
    font-style: italic;
    &::after {
      content: '';
      display: block;
      width: 30px;
      height: 4px;
      background: #2d8cf0;
    }
  }
  &-desc {
    margin: 20px 0;
    color: #2d8cf0;
    font-weight: 600;
    font-size: 20px;
  }
  &-keywords {
    font-weight: 600;
    font-size: 20px;
    text-align: left;
    margin: 20px 0;
  }
  &-action {
    display: flex;
    justify-content: flex-start;
    margin: 20px 0;
    li {
      width: 120px;
      height: 35px;
      line-height: 35px;
      border-radius: 35px;
      font-size: 14px;
      cursor: pointer;
      border: 1px solid transparent;
      text-align: center;
      &:first-child {
        background: #2d8cf0;
        color: #fff;
        margin-right: 20px;
        &:hover {
          background: lighten(#2d8cf0,10%);
        }
      }
      &:last-child {
        background: #fff;
        color: #2d8cf0;
        border-color: #2d8cf0;
        a {
          display: block;
        }
        &:hover {
          color: lighten(#2d8cf0,10%);
        }
      }
    }
  }
}
</style>
